import styled from 'styled-components'

interface NumberContainerProps {
    textColor?: string
}

export const NumberContainer = styled.div<NumberContainerProps>`
    font-family: ${({ theme }) => theme.typography.font.family.yummo};
    font-size: ${({ theme }) => theme.typography.font.size.xLarge};
    font-weight: bold;
    color: ${props => props.textColor || props.theme.colors.white};
`
